/**
 * components/SalesRemintWarningModal.js
 * "Peringatan Nomor Invoice" — a speed bump, not a wall, mirroring `StockWarningModal.js`'s own
 * exact shape and the same "Tetap Lanjutkan"/"Batal & Koreksi" pair (bug fix — "warn before
 * abandoning a number"). Shown right before saving a Cabang-anchored Penjualan/Transfer edit
 * whose salesperson is genuinely being reassigned to a DIFFERENT PERSON at a DIFFERENT BRANCH —
 * `TransactionFormModal.js`'s own `submit()` computes the exact same `personChanged &&
 * branchChanged` condition App.js's `editTransaction` re-mint gate uses (see that function's own
 * header comment, root CLAUDE.md's invariant 19 entry) and short-circuits into this modal instead
 * of saving immediately, the exact same way `StockWarningModal` already short-circuits on a
 * negative-stock line. Never fires on a same-person branch move (nothing is abandoned there —
 * the number simply stays) or a same-branch person reassignment (no re-mint happens there either,
 * untouched, pre-existing, documented behavior this batch deliberately does not touch).
 *
 * "Tetap Lanjutkan" proceeds with the save exactly as if this modal never existed; "Batal &
 * Koreksi" (or Esc, or clicking outside) closes it and returns to the form with every field
 * exactly as the user left it — nothing is reset, same contract as StockWarningModal.
 *
 * Follows the app's standard modal-shell + useModalEsc convention.
 */
import React from "react";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function SalesRemintWarningModal({ oldName, newName, oldInvoiceNumber, onProceed, onCancel }) {
  useModalEsc(onCancel);

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onCancel)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Peringatan Nomor Invoice</h2>
        <div className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>
          Sales pada transaksi ini akan berubah dari <b>{oldName}</b> menjadi <b>{newName}</b>.
          Nomor invoice saat ini, <b>{oldInvoiceNumber}</b>, akan ditinggalkan (tidak bisa dipakai
          lagi) dan nomor baru akan dibuat atas nama {newName}.
        </div>
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onCancel}>Batal &amp; Koreksi</button>
          <button type="button" className="btn btn-primary" onClick={onProceed}>Tetap Lanjutkan</button>
        </div>
      </div>
    </div>
  );
}
